import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DtoEmployeeList} from "./models/DtoEmployeeList";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {EmployeeService} from "./employee.service";
import {SharedService} from "../../shared/shared.service";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {Router} from "@angular/router";
import {EmployeeCreateComponent} from "./employee-create.component";
import {DialogService} from "@progress/kendo-angular-dialog";


@Component({
    selector: 'app-employee-list',
    template: require('./employee-list.component.html'),
    styles: [require('./employee-list.component.css')]
})

@AutoUnsubscribe()
export class EmployeeListComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'FILTEROPTIES',
        buttonDefinition: []
    };
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    filterForm: FormGroup = this.fb.group({
        showInactive: false
    });
    pshbConfig: PageSubheaderBarConfig = {
        title: 'MEDEWERKERS',
        buttonDefinition: [
            {
                clickEventType: 'create',
                description: 'TOEVOEGEN',
                isSmall: false
            },
            {
                clickEventType: 'edit',
                description: 'WIJZIGEN',
                isSmall: false
            },
            {
                clickEventType: 'delete',
                description: 'VERWIJDEREN',
                isSmall: false
            }
        ]
    };
    data: DtoEmployeeList[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'profileImage',
            label: '',
            type: 'image',
            width: '120px',
            style: 'grid-image-column'
        },
        {
            key: 'index',
            label: 'Volgnummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'firstname',
            label: 'Voornaam',
            type: 'string',
            width: '150px'
        },
        {
            key: 'infix',
            label: 'Tussenvoegsel',
            type: 'string',
            width: '140px'
        },
        {
            key: 'lastname',
            label: 'Achternaam',
            type: 'string',
            width: '*'
        },
        {
            key: 'caoGroup',
            label: 'CAO groep',
            type: 'string',
            width: '200px'
        },
        {
            key: 'phoneNumber',
            label: 'Telefoonnummer',
            type: 'string',
            width: '150px'
        },
        {
            key: 'mobileNumber',
            label: 'Mobielnummer',
            type: 'string',
            width: '150px'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private ds: EmployeeService,
                private dialogService: DialogService,
                private router: Router) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'medewerkers', isLastStep: false },
            { text: 'medewerkergegevens', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterForm.get('showInactive').valueChanges.subscribe(newVal => {
            this.filterData();
        });

        this.ds.getEmployeeBaseItems(true).subscribe(() => {
            setTimeout(() => {
                this.loadData(false);
            });
        });
    }

    loadData(reload: boolean) {
        if (reload || !this.data) {
            this.ds.getEmployeeList().subscribe((res: DtoEmployeeList[]) => {
                this.data = res;
                this.filterData();
            });
        }
    }

    filterData() {
        let filteredData = this.data;

        if (!this.filterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.isActive);
        }

        this.grid.hasImages = this.dataHasImages(filteredData);
        this.grid.showData(filteredData);
    }

    dataHasImages(checkData: DtoEmployeeList[]) {
        let foundImage = false;
        if (checkData) {
            checkData.forEach((item) => {
                if (item.profileImage) {
                    foundImage = true;
                }
            });
        }

        return foundImage;
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.filterData();
        } else if (event == 'clear') {
            this.filterForm.reset({ showInactive: false });
            this.filterData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'create') {
            this.showEmployeeCreateWindow();
        } else if (event == 'edit') {
            if (this.grid.getSelectedId() > 0) {
                this.router.navigate(['/auth/employee', this.grid.getSelectedId()]);
            }
        } else if (event == 'delete') {
            if (this.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEmployeeById(this.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadData(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    showEmployeeCreateWindow() {
        const dialogRef = this.dialogService.open({
            content: EmployeeCreateComponent
        });

        const dialogContent: EmployeeCreateComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
    }

    gridRowdoubleClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            this.router.navigate(['/auth/employee', this.grid.getSelectedId()]);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/employees/employee-details/employee-list.component.ts